import React, { useState, useEffect } from "react";
import Courses from "./Courses";
import UserSetting from "./UserSetting";
import Interview from "./Interview";
import CreditPoints, { PurchaseCredits } from "./creditPoints";
import { useStores } from "../../store";
import { InterviewsCompleted } from "./dashboard";
import Experiences from "./experience";
import ViewCredits from "../dashboard/viewCredits";
import { toJS } from "mobx";
import { IoMdShare } from "react-icons/io";
import ReferAndEarn from "./ReferAndEarn";
import { Observer } from "mobx-react";
import TopicBasedInterview from "./topicBasedInterview";
import Create from "./create";
import CompanyBasedInnterview from "./CompanyBasedInnterview";
import KnowMore from "./knowMore";
import { GetMoreCreditsPopUp, RedeemCoupon } from "./basicDetails";
import MobileVerification from "./mobileVerification";
import { useLocation, useNavigate } from "react-router-dom";
import { AiOutlineDelete, AiOutlineDollar } from "react-icons/ai";
import { MdLogout } from "react-icons/md";
import { PiExamLight, PiSuitcaseSimple } from "react-icons/pi";
import { IoPersonOutline, IoSettingsOutline } from "react-icons/io5";
import DeletePopup from "../recruiter/DeletePopup";
import ConfirmationPopup from "../reusble_components/profile/confirmationpopup";
// import { useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import PreviousSubscription from "../reusble_components/Pricing/previousSubscription";
import MoreSettings from "./moreSettings";
import { logout } from "../../api/api_methods";
export default function UserData() {
  const [activeTab, setActiveTab] = useState(1);
  const { UserStore, PopupStore, Recr } = useStores();
  const [user, setUser] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const [subscriptions, setSubscriptions] = useState([]);

  useEffect(() => {
    const tab = new URLSearchParams(location.search).get("tab");
    if (tab) {
      setActiveTab(parseInt(tab));
    }
  }, [location.search]);

  useEffect(() => {
    const loadSub = async () => {
      const sub = await UserStore.checkSubscription();
      setSubscriptions(sub);
    };
    loadSub();
    const userDetail = localStorage.getItem("user");
    if (userDetail) {
      setUser(JSON.parse(userDetail));
    } else {
      console.log("No user data found in localStorage");
    }
    console.log("User Detail:", toJS(userDetail));
  }, []);

  const [showPopup, setShowPopup] = useState(false);
  const userLogOut = async () => {
    try {
      await logout();
    } catch (error) {}
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace("/login");
  };

  return (
    <Observer>
      {() => (
        <div className="h-fit w-[100%] bg-white ">
          {PopupStore.topicbasedinterview && (
            <TopicBasedInterview
              popUpInitialValue={PopupStore.topicbasedinterview}
              handlePopup={() => {
                PopupStore.setTopicBasedInterview(false);
              }}
            />
          )}
          {PopupStore.createinterview && (
            <Create
              popUpInitialValue={PopupStore.createinterview}
              handlePopup={() => {
                PopupStore.setCreateInterview(false);
              }}
            />
          )}

          {PopupStore.companyBasedInterview && (
            <CompanyBasedInnterview
              popUpInitialValue={PopupStore.companyBasedInterview}
              handlePopup={() => {
                PopupStore.setCompanyBasedInterview(false);
              }}
            />
          )}
          {PopupStore.KnowMore && (
            <KnowMore
              popUpInitialValue={PopupStore.KnowMore}
              handlePopup={() => {
                PopupStore.setKnowMore(false);
              }}
            />
          )}

          {PopupStore.getMoreCredits && (
            <GetMoreCreditsPopUp
              popUpInitialValue={PopupStore.getMoreCredits}
              handlePopup={() => {
                PopupStore.setGetMoreCredits(false);
              }}
            />
          )}
          {PopupStore.mobileVerfication && (
            <MobileVerification
              popUpInitialValue={true}
              handlePopup={() => {
                PopupStore.setMobileVerfication(false);
              }}
            />
          )}
          {PopupStore.redeemCoupon && (
            <RedeemCoupon
              popUpInitialValue={true}
              handlePopup={() => {
                PopupStore.setRedeemCoupon(false);
              }}
            />
          )}

          {PopupStore.paymentGateway && (
            <PurchaseCredits
              gateWay="phonePe"
              onClose={() => {
                PopupStore.setPaymentGateway(false);
              }}
            />
          )}
          {PopupStore.referAndEarn && (
            <ReferAndEarn
              popUpInitialValue={PopupStore.referAndEarn}
              handlePopup={() => {
                PopupStore.setReferAndEarn(false);
              }}
            />
          )}
          {UserStore.DeletePopup ? <DeletePopup /> : null}
          {/* <MockTestAnalyticsPopup /> */}
          {/* <MockTestAnalytics /> */}
          <div className="flex  justify-between ml-6 items-center">
            <div className="flex tc1:pl-2 -ml-2 sm:px-5 items-center mt-10 space-x-10 md:space-x-20 lg:space-x-24 pl-6 tc1:overflow-x-scroll md:overflow-visible lg:overflow-visible no-scrollbar">
              {/* User Info */}
              <div
                className={`flex items-center space-x-2 py-2 min-w-fit cursor-pointer ${
                  activeTab === 1
                    ? "text-orange-500 border-b-2 border-primary -mb-[1.5px] px-1"
                    : "hover:text-primary"
                }`}
                onClick={() => {
                  setActiveTab(1);
                  navigate("/dashboard/settings?tab=1");
                }}
              >
                <IoPersonOutline className="" />
                <label className="cursor-pointer">User Info</label>
              </div>

              {/* Previous Experience */}
              <div
                className={`flex items-center space-x-2 py-2 min-w-fit cursor-pointer ${
                  activeTab === 5
                    ? "text-orange-500 border-b-2 border-primary -mb-[1.5px] px-1"
                    : "hover:text-primary"
                }`}
                onClick={() => {
                  setActiveTab(5);
                  navigate("/dashboard/settings?tab=5");
                }}
              >
                <PiSuitcaseSimple className="" />
                <label className="cursor-pointer">Previous Experience</label>
              </div>

              {/* Interview */}
              <div
                className={`flex items-center space-x-2 py-2 min-w-fit cursor-pointer ${
                  activeTab === 3
                    ? "text-orange-500 border-b-2 border-primary -mb-[1.5px] px-1"
                    : "hover:text-primary"
                }`}
                onClick={() => {
                  setActiveTab(3);
                  navigate("/dashboard/settings?tab=3");
                }}
              >
                <PiExamLight className="" />
                <label className="cursor-pointer">Interview</label>
              </div>

              {/* Subscription */}
              <div
                className={`flex items-center space-x-2 py-2 min-w-fit cursor-pointer ${
                  activeTab === 6
                    ? "text-orange-500 border-b-2 border-primary -mb-[1.5px] px-1"
                    : "hover:text-primary"
                }`}
                onClick={() => {
                  setActiveTab(6);
                  navigate("/dashboard/settings?tab=6");
                }}
              >
                <AiOutlineDollar className="" />
                <label className="cursor-pointer">Subscription</label>
              </div>

              {/* Credits */}
              <div
                className={`flex items-center space-x-2 py-2 min-w-fit cursor-pointer ${
                  activeTab === 4
                    ? "text-orange-500 border-b-2 border-primary -mb-[1.5px] px-1"
                    : "hover:text-primary"
                }`}
                onClick={() => {
                  setActiveTab(4);
                  navigate("/dashboard/settings?tab=4");
                }}
              >
                <AiOutlineDollar className="" />
                <label className="cursor-pointer">Credits</label>
              </div>
              <div
                className={`flex items-center space-x-2 py-2 min-w-fit cursor-pointer ${
                  activeTab === 7
                    ? "text-orange-500 border-b-2 border-primary -mb-[1.5px] px-1"
                    : "hover:text-primary"
                }`}
                onClick={() => {
                  setActiveTab(7);
                  navigate("/dashboard/settings?tab=7");
                }}
              >
                <IoSettingsOutline className="" />
                <label className="cursor-pointer">More settings</label>
              </div>
            </div>
            <div className="flex mt-8 mr-12 ">
              <button
                className="flex justify-center items-center  text-primary p-1 rounded-lg mr-2 "
                onClick={() => PopupStore.setReferAndEarn(true)}
              >
                {/* <MdLogout /> */}
                <div className="relative group">
                  <IoMdShare />
                  {/* Tooltip */}
                  <div
                    className={`absolute hidden group-hover:flex items-center bottom-full mb-3 left-1/2 transform -translate-x-1/2 
                       bg-[#EFEFEF] bg-opacity-100 z-20 text-black text-[12px] leading-5 p-3 rounded-lg  w-fit  whitespace-normal `}
                  >
                    <div className="absolute bottom-[-8px] left-1/2 transform -translate-x-1/2 w-0 h-0 border-x-8 border-x-transparent border-t-8 border-t-[#EFEFEF]"></div>
                    Share{" "}
                  </div>
                </div>
              </button>
              <button
                className="flex justify-center items-center  text-primary p-1 rounded-lg mr-2 "
                onClick={() => setShowPopup(true)}
              >
                {/* <MdLogout /> */}
                <div className="relative group flex items-center gap-2">
                  <MdLogout />
                  <h1>Logout</h1>
                  {/* Tooltip */}
                  <div
                    className={`absolute hidden group-hover:flex items-center bottom-full mb-3 left-1/2 transform -translate-x-1/2 
                       bg-[#EFEFEF] bg-opacity-100 z-20 text-black text-[12px] leading-5 p-3 rounded-lg  w-fit  whitespace-normal `}
                  >
                    <div className="absolute bottom-[-8px] left-1/2 transform -translate-x-1/2 w-0 h-0 border-x-8 border-x-transparent border-t-8 border-t-[#EFEFEF]">
                      {" "}
                    </div>
                    Logout{" "}
                  </div>
                </div>
              </button>
              <ConfirmationPopup
                message="Do you really want to log out?"
                cancelButton="Cancel"
                confirmButton="Yes, Logout"
                onConfirm={userLogOut}
                onCancel={() => setShowPopup(false)}
                open={showPopup}
                onOpenChange={setShowPopup}
              />
              {/* <button
                className="flex justify-center items-center  text-[#FF0000] p-1 rounded-lg mr-4"
                onClick={() => UserStore.setDeletePopup(true)}
              >
                
                <div className="relative group">
                  <AiOutlineDelete />
                 
                  <div
                    className={`absolute hidden group-hover:flex items-center bottom-full mb-3 left-1/2 transform -translate-x-1/2 
                       bg-[#EFEFEF] bg-opacity-100 z-20 text-black text-[12px] leading-5 p-3 rounded-lg  w-fit  whitespace-normal `}
                  >
                    <div className="absolute bottom-[-8px] left-1/2 transform -translate-x-1/2 w-0 h-0 border-x-8 border-x-transparent border-t-8 border-t-[#EFEFEF]"></div>
                    Delete{" "}
                  </div>
                </div>
              </button> */}
            </div>
          </div>
          {activeTab === 1 && <UserSetting />}
          {activeTab === 5 && <Experiences />}
          {activeTab === 2 && <Courses />}
          {activeTab === 3 && <Interview />}
          {activeTab === 6 && (
            <PreviousSubscription subscriptions={subscriptions} />
          )}
          {activeTab === 4 && (
            <div className="w-full border-t flex flex-col items-center h-[85vh] overflow-hidden scrollbar-n mt-auto">
              <div className="m-auto flex flex-col md:flex-row lg:flex-row justify-center items-center w-full">
                <CreditPoints
                  className="w-[50%]"
                  availableCredits={UserStore.userDetails?.coins ?? 0}
                />
                <div className="md:w-[50%] lg:w-[50%] w-full lg:mt-7 md:mt-7">
                  <InterviewsCompleted className="w-full" />
                </div>
              </div>
              <div className="md:w-full mb-4 overflow-x-auto ">
                <ViewCredits availableCredits={user?.coins ?? 0} />
              </div>
            </div>
          )}
          {activeTab === 7 && <MoreSettings />}
        </div>
      )}
    </Observer>
  );
}
